module.exports = __webpack_public_path__ + "static/node-33204a2ec9e8d51cc720cd95a5960eff.svg";